import { Button, Text, Title2, makeStyles, tokens } from '@fluentui/react-components';
import { useAuth } from '@worklogix/web-common';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingVerticalM,
    minHeight: '100vh',
    padding: tokens.spacingHorizontalXXL,
    textAlign: 'center',
    backgroundColor: tokens.colorNeutralBackground1,
    color: tokens.colorNeutralForeground1,
  },
  detail: {
    color: tokens.colorNeutralForeground3,
    maxWidth: '520px',
  },
});

export interface NoAccessProps {
  /** Optional diagnostic line (e.g. "access probe returned HTTP 403"). */
  detail?: string;
}

/**
 * Full-screen "no platform access" state for the console SITE. The console is
 * platform-admin only; when the `GET /platform/access` probe returns any
 * non-200 (403, 401, network, 5xx) the gate fails closed and lands here rather
 * than ever showing a tenant-app fallback (that is a separate site) or a blank
 * page. The signed-in user can read why and sign out to switch accounts.
 */
export function NoAccess({ detail }: NoAccessProps): JSX.Element {
  const styles = useStyles();
  const { displayName, logout } = useAuth();

  return (
    <main className={styles.root}>
      <Title2 as="h1">You don&apos;t have platform access</Title2>
      <Text>
        {displayName !== null ? `${displayName}, this account ` : 'This account '}
        is not authorized for the WorkLogix platform-admin console.
      </Text>
      {detail !== undefined && detail !== '' ? (
        <Text size={200} className={styles.detail}>
          <code>{detail}</code>
        </Text>
      ) : null}
      <Button appearance="primary" onClick={() => void logout()}>
        Sign out
      </Button>
    </main>
  );
}
